<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-6">
        <div class="d-flex align-items-center gap-2">
          <h5 class="modal-title" i18n>Booking Settings</h5>
          <app-page-help articleId="yflm0vnrkt" videoId="-"></app-page-help>
        </div>
      </div>
      <div class="col-sm-6 btn-holder text-right">
        <button
          (click)="save(form)"
          [disabled]="!isFullSync || (1 | isReadonlyRole)"
          type="button"
          class="btn btn-secondary-info"
        >
          <span class="cs-icon cs-icon-save"></span>
          <ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="main-content">
        <div class="alert alert-warning" *ngIf="!isFullSync">
          <ng-container i18n>In order to manage booking settings,</ng-container>
          <strong i18n>Full Synchronization</strong>
          <ng-container i18n>should be enabled for this listing.</ng-container>
          <button class="btn btn-secondary-info" (click)="onUpdateSyncCategoryAirBnBV2()">
            <i class="fal fa-exchange"></i> <ng-container i18n>Change Synchronization</ng-container>
          </button>
        </div>
        <form [formGroup]="form">
          <mat-accordion class="d-flex flex-column gap-3">
            <mat-expansion-panel [expanded]="true" class="bg-white rounded shadow2">
              <mat-expansion-panel-header>
                <mat-panel-title class="text-md" i18n> Policies </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row" formGroupName="cancellation_policy_settings">
                <div class="col-sm-12">
                  <h6 class="mb-3">
                    <ng-container i18n>Standard cancellation policy</ng-container>
                    <small class="text-muted d-block" i18n
                      >Choose the policy that will apply to stays under 28 nights.</small
                    >
                  </h6>
                </div>
                <div class="col-sm-12">
                  <mat-radio-group formControlName="cancellation_policy_category">
                    <div *ngFor="let policy of cancellationPolicies" class="policy">
                      <mat-radio-button [value]="policy.value">
                        {{ policy.title }}
                      </mat-radio-button>
                      <div class="policy_description">
                        {{ policy.description }}
                      </div>
                    </div>
                  </mat-radio-group>
                </div>
                <div class="col-sm-12 mt-3">
                  <h6 class="mb-3">
                    <ng-container i18n>Long-term stay cancellation policy</ng-container>
                    <small class="text-muted d-block" i18n
                      >Choose the policy that will apply to stays 28 nights or longer.</small
                    >
                  </h6>
                </div>
                <div class="col-sm-12">
                  <mat-radio-group formControlName="lts_cancellation_policy_id">
                    <div *ngFor="let policy of longTermCancellationPolicies" class="policy">
                      <mat-radio-button [value]="policy.value">
                        {{ policy.title }}
                      </mat-radio-button>
                      <div class="policy_description">
                        {{ policy.description }}
                      </div>
                    </div>
                  </mat-radio-group>
                </div>
                <div class="col-sm-4">
                  <mat-form-field2 class="mat-block subscript-static">
                    <input
                      type="number"
                      formControlName="non_refundable_price_factor"
                      matInput
                      placeholder="Non-refundable Discount"
                      i18n-placeholder
                      matTooltip="In addition to selected cancellation policy, offer a non-refundable option—guests pay less, but you keep your payout no matter when they cancel."
                      i18n-matTooltip
                    />
                    <span matSuffix>%</span>
                    <mat-hint *ngIf="isDiscountIneligible" i18n>
                      Airbnb doesn't support a non-refundable discount with Super Strict cancellation policies.
                    </mat-hint>
                    <mat-error *ngIf="cancellationPolicy.get('non_refundable_price_factor').hasError('min')">
                      <ng-container i18n>Value should be greater than 0</ng-container>
                    </mat-error>
                    <mat-error *ngIf="cancellationPolicy.get('non_refundable_price_factor').hasError('max')">
                      <ng-container i18n>Value should be less than 100</ng-container>
                    </mat-error>
                  </mat-form-field2>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <mat-form-field2 class="mat-block">
                    <mat-select
                      placeholder="Instant Book"
                      i18n-placeholder
                      formControlName="instant_booking_allowed_category"
                      matTooltip="When this is on, bookings are accepted automatically. When off, you’ll need to manually accept or decline booking requests for selected guest."
                      i18n-matTooltip
                    >
                      <mat-option [value]="item.value" *ngFor="let item of airbnbInstantBookingAllowedCategories">
                        {{ item.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field2>
                </div>
                <div class="col-sm-12">
                  <div class="alert alert-warning">{{ turnOffInstantBookingWarning }}</div>
                </div>
                <div class="col-sm-12">
                  <mat-form-field2 class="mat-block">
                    <textarea
                      formControlName="instant_book_welcome_message"
                      matInput
                      rows="3"
                      placeholder="Pre-booking message"
                      i18n-placeholder
                      cdkTextareaAutosize
                    ></textarea>
                  </mat-form-field2>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="bg-white rounded shadow2">
              <mat-expansion-panel-header>
                <mat-panel-title class="text-md" i18n> House rules </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-grid gap-3" formGroupName="guest_controls" style="grid-template-columns: repeat(3, 1fr)">
                <mat-checkbox formControlName="allows_events_as_host" i18n>Events allowed</mat-checkbox>
                <mat-checkbox formControlName="allows_smoking_as_host" i18n>
                  Smoking, vaping, e‑cigarettes allowed
                </mat-checkbox>
                <mat-checkbox formControlName="allows_pets_as_host" i18n>Pets allowed</mat-checkbox>
              </div>
              <app-airbnb-special-considerations
                [connection]="data.connection"
                [isFullSync]="isFullSync"
                [readOnly]="1 | isReadonlyRole"
              ></app-airbnb-special-considerations>

              <div class="row">
                <div class="col-sm-4">
                  <mat-form-field2 class="mat-block">
                    <mat-select placeholder="Check in start" i18n-placeholder formControlName="check_in_time_start">
                      <mat-option [value]="item.value" *ngFor="let item of airbnbCheckinStartTimeOptions">
                        {{ item.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field2>
                </div>
                <div class="col-sm-4">
                  <mat-form-field2 class="mat-block">
                    <mat-select placeholder="Check in end" i18n-placeholder formControlName="check_in_time_end">
                      <mat-option [value]="item.value" *ngFor="let item of airbnbCheckinEndTimeOptions">
                        {{ item.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field2>
                </div>
                <div class="col-sm-4">
                  <mat-form-field2 class="mat-block">
                    <mat-select placeholder="Checkout time" i18n-placeholder formControlName="check_out_time">
                      <mat-option [value]="item.value" *ngFor="let item of airbnbCheckoutTimeOptions">
                        {{ item.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field2>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="bg-white rounded shadow2">
              <mat-expansion-panel-header>
                <mat-panel-title class="text-md" i18n> Listing Expectations for Guests</mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row" *ngFor="let item of expectations.controls; let i = index" [formGroup]="item">
                <div class="col-sm-4">
                  <mat-form-field2 class="mat-block">
                    <mat-select placeholder="Type" formControlName="type" required>
                      <mat-option [value]="item.value" *ngFor="let item of airbnbListingExpectationTypes">
                        {{ item.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field2>
                </div>
                <div class="col">
                  <mat-form-field2 class="mat-block">
                    <input formControlName="added_details" matInput placeholder="Details" />
                    <a
                      href="javascript:;"
                      class="text-danger"
                      matTooltip="Remove this expectation"
                      i18n-matTooltip
                      (click)="onRemoveExpectation(i)"
                      matSuffix
                    >
                      <i class="cs-icon cs-icon-trash"></i>
                    </a>
                  </mat-form-field2>
                </div>
              </div>
              <div>
                <button class="btn btn-secondary-info" (click)="onAddExpectation()">
                  <i class="far fa-plus"></i> <ng-container i18n>Add Expectation</ng-container>
                </button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </form>
      </div>
    </div>
  </div>
</div>
